/* eslint-disable perfectionist/sort-imports */
import 'react-day-picker/style.css';
import 'src/global.css';

// ----------------------------------------------------------------------

import ThemeProvider from 'src/theme';

import ProgressBar from 'src/components/progress-bar';
import { SettingsDrawer, SettingsProvider } from 'src/components/settings';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';

import {
  AC_AUTHORITY,
  CALLBACK_URL,
  POSTLOGOUT_URL,
  SUPERSET_DOMAIN,
  AC_AUTHORITY_CLIENT_SECRET,
} from 'src/config-global';
import {
  MotionLazy,
  ApiProvider,
  AuthProvider,
  useScrollToTop,
  SupersetProvider,
  QueryClientWrapper,
} from '@emfood/shared';
import { Outlet, RouterProvider } from '@tanstack/react-router';
import { enqueueSnackbar } from 'notistack';
import { Stack, Typography } from '@mui/material';
import { LocalizationProvider } from './locales';
import { endpoints } from './api/api-config';
import { mainRouter } from './routes/sections';

export const RootLayout = () => {
  useScrollToTop();

  return (
    <AuthProvider
      currentUserEndpoint={`${endpoints.getCurrentUser}`}
      userManagerSettings={{
        scope: 'openid profile offline_access',
        authority: AC_AUTHORITY,
        client_id: 'ac-backoffice-ui',
        redirect_uri: CALLBACK_URL,
        // Important: The prompt value needs to be configired to match ac-authority
        prompt: 'login consent',
        post_logout_redirect_uri: POSTLOGOUT_URL,
        client_secret: AC_AUTHORITY_CLIENT_SECRET,
        response_type: 'code',
        stateStore: undefined,
      }}
    >
      <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark'
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: true,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <SnackbarProvider>
                <ApiProvider>
                  <SupersetProvider supersetDomain={SUPERSET_DOMAIN} authority={AC_AUTHORITY}>
                    <QueryClientWrapper
                      onError={(data) => {
                        enqueueSnackbar(
                          <Stack sx={{ maxWidth: 800 }}>
                            <Typography fontWeight={600} variant="inherit">
                              {data.message}
                            </Typography>
                            {data.requestId && (
                              <Typography
                                fontSize={11}
                                color="text.secondary"
                                variant="inherit"
                              >{`Request Id: ${data.requestId}`}</Typography>
                            )}
                          </Stack>,
                          { variant: 'error' }
                        );
                      }}
                    >
                      <SettingsDrawer />
                      <ProgressBar />
                      <Outlet />
                    </QueryClientWrapper>
                  </SupersetProvider>
                </ApiProvider>
              </SnackbarProvider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </AuthProvider>
  );
};

export default function App() {
  return <RouterProvider router={mainRouter} />;
}
